<script setup>
import SubscriptionTile from './../components/subscription-tile.vue'

defineProps({
    plans: {
        type: Array,
        default: () => [],
    },
    currentSubscription: {
        type: Object,
        default: () => ({}),
    },
    isLoggedIn: {
        type: Boolean,
        default: false,
    },
    isEntitledFreeTrial: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['onAction'])

function onAction(plan) {
    emit('onAction', plan)
}
</script>

<template>
    <div
        v-if="plans.length"
        class="plans-block"
    >
        <SubscriptionTile
            v-for="plan in plans"
            :key="`plan-tile-${plan.id}`"
            :current-subscription="currentSubscription"
            :plan="plan"
            :is-logged-in="isLoggedIn"
            :is-entitled-free-trial="isEntitledFreeTrial"
            @on-action="onAction"
        />
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.plans-block {
    display: flex;
    flex-direction: column;
    gap: $s-m;
    align-items: center;
    margin-top: $s-m;
}

@include tablet {
    .plans-block {
        flex-direction: row;
    }
}
</style>
